import { EntityCommandRequest } from '../entities/views/entity.view.request';

export const NotificationCqrsActions = {
    getItems: 'NotificationGetItemsQuery',
    getById: 'NotificationGetByIdQuery',
    getUnreadCount: 'NotificationGetUnreadCountQuery',
    getSources: 'NotificationGetSourcesQuery',
    markAsRead: 'NotificationMarkAsReadCommand',
    markAsUnread: 'NotificationMarkAsUnreadCommand',
    markAllAsRead: 'NotificationMarkAllAsReadCommand',
    markAllAsUnread: 'NotificationMarkAllAsUnreadCommand',
    snooze: 'NotificationSnoozeCommand',
    unsnooze: 'NotificationUnsnoozeCommand',
    delete: 'NotificationDeleteCommand',
    deleteAll: 'NotificationDeleteAllCommand',
} as const;

export type NotificationCqrsAction = typeof NotificationCqrsActions[keyof typeof NotificationCqrsActions];

export type NotificationCommandRequest = EntityCommandRequest & (
    | { commandId: 'MarkAsRead'; data: { notificationIds: string[] } }
    | { commandId: 'MarkAsUnread'; data: { notificationIds: string[] } }
    | { commandId: 'MarkAllAsRead'; data: null }
    | { commandId: 'MarkAllAsUnread'; data: null }
    | { commandId: 'Snooze'; data: { notificationIds: string[]; snoozedUntil: Date } }
    | { commandId: 'Unsnooze'; data: { notificationIds: string[] } }
    | { commandId: 'Delete'; data: { notificationIds: string[] } }
    | { commandId: 'DeleteAll'; data: { onlyRead?: boolean } }
    | { commandId: 'GetUnreadCount'; data: null }
    | { commandId: 'ResetAndSeedData'; data: null }
    | { commandId: 'FireTestInAppNotification'; data: null }
    | { commandId: 'FireTestEmail'; data: null }
);
